import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../../service/auth.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';


@Component({
  selector: 'app-completeRegister',
  templateUrl: './completeRegister.component.html',
  styleUrls: ['./completeRegister.component.css']
})
export class CompleteRegisterComponent implements OnInit {
  public completeRegisterForm: FormGroup;
  token: string
  data: Object;


  constructor(
    private builder: FormBuilder,
    private route: ActivatedRoute, 
    private authService: AuthService) { }

  ngOnInit() {
    this.completeRegisterForm = this.builder.group({

      password : [ null,  [ Validators.required ] ],
      confirmPassword: [ null, [ Validators.required ] ]
    });

    this.route.params.subscribe(paramsId => {
      this.token = paramsId['token']
  });
    console.log(this.token)
    // this.authService.validateEmail({token:this.token})
    // .then(resp => {
    //   console.log(resp)
    // })

  }

  confirm(){
    this.data = {
      password: this.completeRegisterForm.controls.password.value,
      token: this.token
    };
    console.log(this.data)
    console.log(this.token)
    this.authService.validateUniEmail(this.data)
    .then(resp =>{
      console.log(resp)
      if (resp.status == 200){
        console.log(resp.body)
      }
    })
    .catch(e => {
      console.log(e)
      if (e.status ==409){
        console.log("Not Valid")
      }
    })
  }

}
